import { driverServerInstance, shangjiaServerInstance } from "../axios/instances";
import {
    GET_SERVICE_POINT,
    GET_SERVICE_POINT_SUCCESS,
    GET_SERVICE_POINT_FAIL,
    GET_DRIVER_SERVICE_POINT,
    GET_DRIVER_SERVICE_POINT_SUCCESS,
    GET_DRIVER_SERVICE_POINT_FAIL,
    ASSIGN_SERVICE_POINT,
    ASSIGN_SERVICE_POINT_SUCCESS,
    ASSIGN_SERVICE_POINT_FAIL
 } from './types';

export function getServicePoint(warehouse) {
    return function(dispatch) {
        dispatch({type: GET_SERVICE_POINT})
        return shangjiaServerInstance.post(`/servicepointmanagement/searchservicepoint`, {
            is_active: 0,
            warehouse: warehouse
        })
        .then(({data}) => {
            dispatch({
                type: GET_SERVICE_POINT_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: GET_SERVICE_POINT_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function getDriverServicePoint(driverId) {
    return function(dispatch) {
        dispatch({type: GET_DRIVER_SERVICE_POINT})
        return driverServerInstance.get(`/dropoff/assignment/service_point/${driverId}`)
        .then(({data}) => {
            dispatch({
                type: GET_DRIVER_SERVICE_POINT_SUCCESS,
                payload: data.biz_data
            })
            return Promise.resolve(data.biz_data);
        }).catch(error => {
            dispatch({
                type: GET_DRIVER_SERVICE_POINT_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function assignServicePoint(driverId, servicePointId) {
    return function(dispatch) {
        dispatch({type: ASSIGN_SERVICE_POINT})
        return driverServerInstance.post(`/dropoff/assignment`, {
            driver_id: driverId,
            service_point_id: servicePointId
        })
        .then(({data}) => {
            dispatch({
                type: ASSIGN_SERVICE_POINT_SUCCESS,
                payload: data.biz_data
            })
            return Promise.resolve(data.biz_data);
        }).catch(error => {
            dispatch({
                type: ASSIGN_SERVICE_POINT_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}
